import { createSlice, createSelector } from "@reduxjs/toolkit";
import moment from 'moment/moment';
import { setFileContent } from "../files/FileSlice";

const initialState = {
  id: 0,
  amount: 1,
  articleSerialNumber: '',
  articleAssemblyAddress:'',
  articlePurchaseDate: moment(),
  articleIsCompleted:false,
  articleHasDisassemblySigns:false,
  articlePurchaseAddress:'',
  articlePrice: 0,
  courier: {
      value: 'NotSpecified',
      displayName: ''
  },
  customerRequest: '',
  dateOfReceiptOfGoods: moment(),
  notes: '',
  faultDate: moment(),
  faultDescription: '',
  faultDiscoveryCircumstances: '',
  files:[],
  purchaseProve:[],
  invoiceQuantity: 1,
  product: {
      code: '',
      name: ''
  },
  quantityCorrectionsProposal: {
      value: 'NotSpecified',
      displayName: 'Proposal display name',
      id:0
  },
  salesDocumentNumber: '',
  salesDocumentPosition: '',
  shipmentDescription: '',
  shippingMethod:{
      value: 'NotSpecified',
      displayName: ''
  }, 
  shippedQuantity: 1,
  termOfUse: false,
  termOfUseForSalesWarranty: false,
  termOfUseForWarranty: false,
  waybillNumber: '',
  waybillCourier: {
      value: 'NotSpecified',
      displayName: ''
  },
};

export const complaintPositionSlice = createSlice({
    name: 'complaintPosition',
    initialState,
    reducers: {
        // updateDetails: (state, action) => {
        //   return { ...state, ...action.payload};
        // },
     updateDetails: (state, action) => {
  const newState = { ...state, ...action.payload };

  // Check if files property exists in both state and action payload
  if (state.files && action.payload.files) {
    // If both exist, keep the files from the state
    newState.files = state.files;
  }

  return newState;
},
        setProduct: (state, action) => {
          state.product = action.payload;
        },
        setQuantityCorrectionProposal: (state, action) => {
          state.quantityCorrectionsProposal = action.payload;
        },
        setTermOfUse: (state, action) =>{
          state.termOfUse = action.payload;
        },
        addPosition: (state,action) =>{
          state.complaintPosition = action.payload;
        },
        updatePosition: (state, action) => {
          const { index, position } = action.payload;
          state.positions[index] = position;
        },
        addFile: (state, action) => {
          const filesToAdd = action.payload;
          if (state.files === null) {
            state.files = [];
          }
          state.files = [...state.files, ...filesToAdd];
        },
        removeFileFromPosition: (state, action) => {
          const { index } = action.payload;
          state.files.splice(index, 1);
        },
        deletePosition: () => initialState,
        setShippingMethod: (state,acttion) =>{
          state.shippingMethod = acttion.payload;
        },
        setCourier: (state,action) =>{
          state.courier = action.payload;
        },
        clearAllPositions: (state) =>{
          return initialState;
        },
        clearFilesFromPosition: (state, action) =>{
          state.files = [];
        }
      },
 

    });
    
    export const { updateDetails,setCourier,clearFilesFromPosition, updateArticletName,setShippingMethod, updateArticleCode, setProduct, setTermOfUse,addPosition,addFile, deletePosition,setQuantityCorrectionProposal, updatePosition,removeFileFromPosition,clearAllPositions } =
      complaintPositionSlice.actions;
    export default complaintPositionSlice.reducer;
